import * as crmMailMessageFacadeImpl from "./crmMailMessageFacadeImpl";
import * as mailAccount from "./mailAccount";
import * as mailMessage from "./mailMessage";
import * as ticket from "./ticket";

export const crm = {
  crmMailMessageFacadeImpl,
  mailAccount,
  mailMessage,
  ticket,
};
